import { FC, useState } from 'react';
import {
	Table,
	Form,
	Row,
	Col,
	Select,
	Input,
	Button,
	Divider,
	Space,
	DatePicker,
} from 'antd';
import {
	ArrowLeftOutlined,
	DownloadOutlined,
	LoadingOutlined,
	ArrowRightOutlined,
} from '@ant-design/icons';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import FleetTitle from '@/libs/antd/components/Title';
import { useApp } from '@/App';
import DataRow from '@/libs/antd/components/DataRow';
import {
	useDownloadMPP,
	useMPPHistory,
	useMPPHistoryOptions,
	GetMPPHistoryPayload,
} from '@/libs/fleet-api/services/mpp';
import dayjs from 'dayjs';
import { formatCurrency } from '@/libs/antd/formater';
import { useModals } from '@/components/modals/ModalProvider';
import { useForm } from '@/libs/antd/form';

const HistoryMPPListPage: FC<{
	customerId: string;
	customerName: string;
	bmppGroupName: string;
	bmppGroupId: string;
}> = ({ customerId, customerName, bmppGroupId, bmppGroupName }) => {
	const { openCustomerGroupDetail, openCustomerDetail } = useModals();
	const { navigate } = useApp();

	const { form, fieldName, value } = useForm<{
		searchType: string;
		searchParam: GetMPPHistoryPayload;
	}>();

	console.log(value);

	const defaultSeachParams = {
		customerId,
		pagination: {
			pageNumber: 1,
			pageSize: 10,
		},
	};

	const [searchParam, setSearchParam] =
		useState<GetMPPHistoryPayload>(defaultSeachParams);

	const mppHistoryQuery = useMPPHistory(searchParam);
	const mppHistoryOptionQuery = useMPPHistoryOptions();
	const downloadMPPMutation = useDownloadMPP();

	const dataSource =
		mppHistoryQuery.data?.data.map((record, key) => {
			return {
				...record,
				key,
			};
		}) ?? [];

	const renderSearchType = () => {
		switch (value?.searchType) {
			case 'mpp-date':
				return (
					<Form.Item
						name={fieldName(['searchParam', 'mppDate'])}
						getValueProps={(value) => ({
							value: value && dayjs(value),
						})}
						normalize={(value) => value && dayjs(value).utc(true).toISOString()}
					>
						<DatePicker format={'DD/MM/YYYY'} />
					</Form.Item>
				);

			case 'mpp-status':
				return (
					<Form.Item name={fieldName(['searchParam', 'mppStatusId'])}>
						<Select
							options={mppHistoryOptionQuery.data?.data.mppStatusOptions?.map(
								(option) => {
									return {
										label: option.value,
										value: option.id,
									};
								},
							)}
							style={{ width: '100%' }}
							allowClear
						/>
					</Form.Item>
				);

			case 'application-id':
				return (
					<Form.Item name={fieldName(['searchParam', 'applicationId'])}>
						<Input />
					</Form.Item>
				);

			case 'agreement-no':
				return (
					<Form.Item name={fieldName(['searchParam', 'agreementNo'])}>
						<Input />
					</Form.Item>
				);

			case 'supplier-name':
				return (
					<Form.Item name={fieldName(['searchParam', 'supplierName'])}>
						<Input />
					</Form.Item>
				);

			default:
				return (
					<Form.Item>
						<Input disabled />
					</Form.Item>
				);
		}
	};

	return (
		<Space
			direction="vertical"
			style={{ display: 'flex' }}
			size={'large'}
		>
			<div
				style={{
					display: 'flex',
					gap: 10,
					marginBottom: 30,
				}}
			>
				<div>
					<button
						style={{
							display: 'flex',
							height: 44,
							width: 44,
							fontSize: 24,
							border: 'none',
							alignItems: 'center',
							justifyContent: 'center',
							background: '#1557BC',
							color: 'white',
							cursor: 'pointer',
						}}
						onClick={() => {
							navigate('MPPListPage');
						}}
					>
						<ArrowLeftOutlined />
					</button>
				</div>
				<div style={{ flex: 1 }}>
					<FleetTitle>View History Memo Pencairan Pembiayaan</FleetTitle>
				</div>
			</div>
			<DataRow
				items={[
					[
						[
							'Nama Customer',
							<a
								href="#"
								onClick={() => openCustomerDetail(customerId)}
							>
								{customerName}
							</a>,
						],
						[
							'Group Customer BMPP',
							<a
								href="#"
								onClick={() => openCustomerGroupDetail(bmppGroupId)}
							>
								{bmppGroupName}
							</a>,
						],
					],
				]}
			/>
			<Form
				{...ANTD_DEFAULT_PROPS.FORM}
				form={form}
				layout="horizontal"
				colon={false}
				labelAlign="left"
				onFinish={(values) => {
					if (values.searchParam) {
						setSearchParam({
							...defaultSeachParams,
							...values.searchParam,
						});
					} else {
						setSearchParam(defaultSeachParams);
					}
				}}
			>
				<Form.Item
					noStyle
					shouldUpdate
				>
					{() => {
						return (
							<Row gutter={[20, 20]}>
								<Col flex="none">
									<Form.Item
										name={fieldName('searchType')}
										label={<span>Kata Kunci</span>}
										labelCol={{ flex: 'auto', style: { width: 150 } }}
										wrapperCol={{ flex: 'none', style: { width: 250 } }}
									>
										<Select
											loading={mppHistoryOptionQuery.isLoading}
											disabled={mppHistoryOptionQuery.isLoading}
											placeholder="Search By"
											options={
												mppHistoryOptionQuery.data?.data?.searchByOptions?.map(
													(option) => {
														return {
															label: option.value,
															value: option.id,
														};
													},
												) ?? []
											}
											allowClear
											style={{
												display: 'block',
												width: '100%',
											}}
											onSelect={() => {
												form.resetFields([fieldName('searchParam')]);
											}}
										/>
									</Form.Item>
								</Col>
								<Col flex="auto">{renderSearchType()}</Col>
								<Col>
									<Form.Item>
										<Button
											block
											type="primary"
											htmlType="submit"
											disabled={mppHistoryOptionQuery.isLoading}
										>
											SEARCH
										</Button>
									</Form.Item>
								</Col>
							</Row>
						);
					}}
				</Form.Item>
			</Form>

			<Divider style={{ margin: 0 }} />

			<Table
				loading={mppHistoryQuery.isFetching}
				bordered
				scroll={{ x: 'max-content' }}
				dataSource={dataSource}
				columns={[
					{
						title: 'No',
						fixed: 'left',
						align: 'center',
						width: 1,
						render: (_, __, index) => index + 1,
					},
					{
						title: 'No.MKL',
						render: (_, record) => record.mklNo ?? '-',
					},
					{
						title: 'No. MPP',
						render: (_, record) =>
							record.mppNo && record.mppId ? (
								<a
									href="#"
									onClick={(e) => {
										e.preventDefault();
										navigate('MPPPage', {
											mppId: record.mppId,
											viewOnly: true,
											onBack: () => {
												navigate('HistoryMPPListPage', {
													customerId,
													customerName,
													bmppGroupId,
													bmppGroupName,
												});
											},
										});
									}}
								>
									{record.mppNo}
								</a>
							) : (
								'-'
							),
					},
					{
						title: 'Tanggal MPP',
						render: (_, record) =>
							record.mppDate ? dayjs(record.mppDate).format('DD/MM/YYYY') : '-',
					},
					{
						title: 'NTF',
						render: (_, record) =>
							record.ntf ? formatCurrency(record.ntf) : '-',
					},
					{
						title: 'No PO',
						render: () => '-',
					},
					{
						title: 'Application ID',
						render: (_, record) => record.applicationId ?? '-',
					},
					{
						title: 'Agreement No',
						render: (_, record) => record.agreementNo ?? '-',
					},
					{
						title: 'Contract Status',
						render: (_, record) => record.mppStatus ?? '-',
					},
					{
						title: 'Supplier Name',
						render: (_, record) => record.supplierName ?? '-',
					},
					{
						title: 'Approval MPP',
						render: (_, record) => record.approval ?? '-',
					},
					{
						title: 'Status MPP',
						render: (_, record) => record.mppStatus ?? '-',
					},
					{
						title: 'Download MPP',
						align: 'center',
						fixed: 'right',
						render: (_, record) =>
							record.mppNo ? (
								<a
									href="#"
									onClick={async (e) => {
										e.preventDefault();
										if (downloadMPPMutation.isPending) return;

										const res = await downloadMPPMutation.mutateAsync({
											mppId: record.mppId,
										});

										const link = document.createElement('a');
										link.href = res.data.signedUrl;
										document.body.appendChild(link);

										link.click();
										document.body.removeChild(link);
									}}
								>
									{downloadMPPMutation.isPending &&
									downloadMPPMutation.variables?.mppId === record.mppId ? (
										<LoadingOutlined />
									) : (
										<DownloadOutlined />
									)}
								</a>
							) : (
								<DownloadOutlined style={{ color: '#bababa' }} />
							),
					},
					{
						title: 'Action',
						align: 'center',
						width: 120,
						fixed: 'right',
						render: (_, { mppId, mppStatus }) =>
							mppStatus === 'RETURN' ? (
								<a
									href="#"
									onClick={(e) => {
										e.preventDefault();
										navigate('MPPPage', { mppId, isReturn: true });
									}}
								>
									<ArrowRightOutlined />
								</a>
							) : (
								<ArrowRightOutlined style={{ color: '#bababa' }} />
							),
					},
				]}
				pagination={{
					total: mppHistoryQuery.data?.data.length ?? 0,
					onChange: (pageNumber) => {
						setSearchParam((prev) => ({
							...prev,
							pagination: {
								...prev.pagination,
								pageNumber,
							},
						}));
					},
				}}
			/>
		</Space>
	);
};

export default HistoryMPPListPage;
